import React from 'react';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import Home from './components/Home/Home';
import About from './components/About/About';
import Projects from './components/Projects/Projects';
import Services from './components/Services/Services';
import Contact from './components/Contact/Contact';
import Skills from './components/Skills/Skills';

function App() {
  return (
    <div className="App">
    <Header />
    <Home />
    <About />
    <Services />
    <Skills />
    <Projects />
    <Contact />
    <Footer />
    </div>
  );
}

export default App;
